// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * fps-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: local
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdatePhoneDTOAPIModel
 */
export interface UpdatePhoneDTOAPIModel {
    /**
     * 
     * @type {string}
     * @memberof UpdatePhoneDTOAPIModel
     */
    phone: string;
}

export function UpdatePhoneDTOAPIModelFromJSON(json: any): UpdatePhoneDTOAPIModel {
    return UpdatePhoneDTOAPIModelFromJSONTyped(json, false);
}

export function UpdatePhoneDTOAPIModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePhoneDTOAPIModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'phone': json['phone'],
    };
}

export function UpdatePhoneDTOAPIModelToJSON(value?: UpdatePhoneDTOAPIModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'phone': value.phone,
    };
}


